import { Dispatch, ExtraArgs, GetState } from '../../types'
import { Dashboard } from '../Dashboard/model';
import * as selectors from './selectors'
import { isNullOrUndefined } from 'util';

/**
 *  Action Constants
 */
export const ChangeDashboards = 'Monitoring/Dashboard/ChangeDashboards';
export const LoadingDashboards = 'Monitoring/Dashboard/Loading';
export const QueryChangeDashboards = 'Monitoring/Dashboard/QueryChange';

/**
 *  Action Type
 */
export type ChangeDashboardsAction = {
  type: 'Monitoring/Dashboard/ChangeDashboards'
  payload: {
    dashboard: Dashboard[],
    filtered: Dashboard[]
  }
}

export type LoadingDashboardsAction = {
  type: 'Monitoring/Dashboard/Loading'
}

export type QueryChangeDashboardsAction = {
  type: 'Monitoring/Dashboard/QueryChange'
  payload: {
    query: string,
    filteredDashboard: Dashboard[]
  }

}

/**
 *  Action Creators
 */
export const changeDashboards = (dash: Dashboard[], filtered: Dashboard[]): ChangeDashboardsAction => ({
  type: ChangeDashboards,
  payload: {dashboard: dash, filtered: filtered}
});
export const changeFilteredDashboard = (query: string, dash: Dashboard[]): QueryChangeDashboardsAction => ({
  type: QueryChangeDashboards,
  payload: {query: query, filteredDashboard: dash}
});

export const fetchDashboards = (query?: string) => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
  dispatch({type: LoadingDashboards});
  return api.ui(getState).search(query).then((dash: Dashboard[]) => {
    dispatch(changeDashboards(
        dash,
        filterDashboard(dash, isNullOrUndefined(query) ? selectors.getQuery(getState()) : query))
    )
  });
};

export const queryChange = (query: string) => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
  dispatch(changeFilteredDashboard(query, filterDashboard(selectors.getDashboards(getState()), query)))
};

const filterDashboard = (dashboards: Dashboard[], query?: string): Dashboard[] => {
  if (isNullOrUndefined(query)) {
    return dashboards
  }

  return dashboards.filter(dash => {
    return dash.title.toLocaleLowerCase().match(query.toLocaleLowerCase())
  })
};
export type DashboardsActions =
  | ChangeDashboardsAction
  | LoadingDashboardsAction
  | QueryChangeDashboardsAction
